import { render, staticRenderFns } from "./Page_ForgottenPassword.vue?vue&type=template&id=6bdff65e&scoped=true&"
import script from "./Page_ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./Page_ForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdff65e",
  null
  
)

export default component.exports